import { trackEvent } from 'helpers/trackerHelpers';
import { useQuery, useMutation } from '@tanstack/react-query';
import { RQAPICall, RQAPICallWithData } from 'store/APIClient';
import { useDispatch } from 'store/hooks';

export const useGetClientMapping = (bind: string) => {
    trackEvent('Mapping fetched', { page: 'support' });
    return useQuery({
        queryKey: ['client-mapping', bind],

        queryFn: async () => {
            const response = await RQAPICallWithData<string[]>({
                endpoint: `support/${bind}/mappings/categories`,
                method: 'GET',
            });
            return response.content.data;
        },
    });
};

export const useResetClientMapping = (bind: string) => {
    trackEvent('mappings reset', { page: 'support' });
    const dispatch = useDispatch();
    return useMutation({
        mutationFn: (category: string) =>
            RQAPICall({
                endpoint: `support/${bind}/mappings/${category}/reset`,
                method: 'POST',
            }),

        onError: (error: Error) => {
            dispatch.vision.notifyUser({
                message: error.message,
                snackType: 'error',
            });
        },

        onSuccess: (response) => {
            dispatch.vision.notifyUser({
                message: response.content.message,
                snackType: 'success',
            });
        },
    });
};

export const useImportClientMapping = (bind: string) => {
    trackEvent('mappings transfered', { page: 'support' });
    const dispatch = useDispatch();
    return useMutation({
        mutationFn: (category: string) =>
            RQAPICall({
                endpoint: `support/${bind}/mappings/${category}/transfert`,
                method: 'POST',
            }),

        onError: (error: Error) => {
            dispatch.vision.notifyUser({
                message: error.message,
                snackType: 'error',
            });
        },

        onSuccess: (response) => {
            dispatch.vision.notifyUser({
                message: response.content.message,
                snackType: 'success',
            });
        },
    });
};
